import { useTranslate } from '@va/localization';
import { Button, GrayGradientDivider, Paragraph } from '@va/ui/design-system';
import {
  CustomDashboardDomainCreationStep,
  useCustomDashboardDomainCreationContext,
} from '../customDashboardDomainCreationContext';

export const ConfirmEffectsStep = () => {
  const translate = useTranslate();
  const { setActiveStep, saveCustomDomain, domain } = useCustomDashboardDomainCreationContext();

  return (
    <div>
      <div className='p-4'>
        <Paragraph>{translate('standalone.customPlatformDomain.confirmDomainChange.line2', { newDomain: domain })}</Paragraph>
      </div>

      <GrayGradientDivider />

      <div className='flex flex-row justify-end p-3 gap-3'>
        <Button
          className='rounded-12 flex-1'
          color='tertiary'
          text={translate('button.back')}
          onClick={() => {
            setActiveStep(CustomDashboardDomainCreationStep.verifyDNS);
          }}
        />
        <Button
          className='rounded-12 flex-2 '
          color='primary'
          text={translate('button.confirmAndSaveChanges')}
          onClick={saveCustomDomain}
        />
      </div>
    </div>
  );
};
